import './Graphic.scss';
import React from 'react';
import gridImage from '../../../images/grid_new.png';
import { Grid } from '@mui/material';
import { useAppSelector } from '../../../../reduxService/hooks';
import { useLocation } from 'react-router-dom';
import TireAndLayersAirportPaved from './TireAndLayersAirportPaved';

export const Graphic = () => {
    const location = useLocation();
    const inResults = location.pathname.split('/')[1] === 'results';

    const dynamicProject = useAppSelector(state => state.Dynamic.project);
    const currentProjectType = dynamicProject?.data?.type ?? 'container_yard';

    return (
        <Grid container id="container" spacing={2} style={{ background: `repeat url(${gridImage})` }}>
            {!inResults && (
                <Grid
                    item
                    xs={12}
                    md={12}
                    id="canvas"
                    style={{
                        minHeight: '500px',
                        display: 'flex', // Usa flexbox
                        justifyContent: 'center', // Centra orizzontalmente
                        alignItems: 'center', // Centra verticalmente
                    }}>
                    <TireAndLayersAirportPaved projectType={currentProjectType} layerHeights={[180, 100]} differenziali={[0.1, 0.2, 0.3]} />
                </Grid>
            )}
        </Grid>
    );
};

export default Graphic;
